import { render, staticRenderFns } from "./PaymentAdminV3.vue?vue&type=template&id=b5f5dac8&scoped=true"
import script from "./PaymentAdminV3.vue?vue&type=script&lang=js"
export * from "./PaymentAdminV3.vue?vue&type=script&lang=js"
import style0 from "./PaymentAdminV3.vue?vue&type=style&index=0&id=b5f5dac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f5dac8",
  null
  
)

export default component.exports